import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/SmartBirdFeedersPage/smartBirdFeedersPage.js");
